const TableBody = ({ tableData, columns }) => {
  return (
    <tbody>
      {tableData.map((data, i) => {
        return (
          <tr key={data.id}>
            <td>{i + 1}</td>
            {columns.map(({ accessor }) => {
              const tData = data[accessor] ? data[accessor] : "——";
              return <td key={accessor}>{tData}</td>;
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

export default TableBody;
